export const epiChatMessagesEn = {
  // Run-completion alert (tab title badge / native notification)
  'epiChat.runComplete.title': 'Research Assistant finished',
  'epiChat.runComplete.body': 'Your request is ready to review.',

  // CohortPlanCard — Checkpoint 2 plan confirmation
  'epiChat.cohortPlan.chip': 'Checkpoint · Cohort plan',
  'epiChat.cohortPlan.awaitingReview': 'Awaiting your review',
  'epiChat.cohortPlan.resolvedBadge': 'Done',
  'epiChat.cohortPlan.noPlanAttached': 'No plan seems to be attached.',
  'epiChat.cohortPlan.studyPeriod': 'Study period: {value}',
  'epiChat.cohortPlan.role.index': 'Index',
  'epiChat.cohortPlan.role.inclusion': 'Inclusion',
  'epiChat.cohortPlan.role.exclusion': 'Exclusion',
  'epiChat.cohortPlan.descriptionPlaceholder': 'Plain-language criterion',
  'epiChat.cohortPlan.approveButton': 'Approve & continue',
  'epiChat.cohortPlan.redirectButton': 'Redirect',
  'epiChat.cohortPlan.redirectPrompt':
    'Tell the agent what to do instead (inline edits will be discarded):',
  'epiChat.cohortPlan.redirectPlaceholder':
    'e.g. Add an exclusion for pregnancy. Or: Stop, build a cohort of biologics initiators instead.',
  'epiChat.cohortPlan.sendButton': 'Send',
  'epiChat.cohortPlan.cancelButton': 'Cancel',
  'epiChat.cohortPlan.approvedAsIs': 'Approved — proceed with the cohort plan as-is.',
  'epiChat.cohortPlan.approvedWithEdits':
    'Approved with {count, plural, one {# edit} other {# edits}} applied.',

  // InterruptedRunCard — multi-pod run-interrupted (lease expired) recovery
  'epiChat.interruptedRun.chip': 'Request interrupted',
  'epiChat.interruptedRun.body':
    'Something interrupted this request before it finished. Retry to continue.',
  'epiChat.interruptedRun.retryButton': 'Retry',
  'epiChat.interruptedRun.retryAriaLabel': 'Retry the interrupted request',

  // VerificationTab — execution history and stat sections
  'epiChat.verification.status.running': 'running',
  'epiChat.verification.status.passed': 'passed',
  'epiChat.verification.status.failed': 'failed',
  'epiChat.verification.status.error': 'error',

  'epiChat.verification.section.measuredPopulation': 'Measured population',
  'epiChat.verification.section.distribution': 'Results',
  'epiChat.verification.section.runDetails': 'Run details',

  'epiChat.verification.stat.fullDataset': 'Full dataset',
  'epiChat.verification.stat.anchor': 'Anchor: ',
  'epiChat.verification.stat.index': 'Index',
  'epiChat.verification.stat.studyPeriod': 'Study period',
  'epiChat.verification.stat.true': 'True',
  'epiChat.verification.stat.false': 'False',
  'epiChat.verification.stat.null': 'Null',
  'epiChat.verification.stat.totalNonNull': 'Total non-null',
  'epiChat.verification.stat.meanSD': 'Mean (SD)',
  'epiChat.verification.stat.medianIQR': 'Median [IQR]',
  'epiChat.verification.stat.min': 'Min',
  'epiChat.verification.stat.max': 'Max',
  'epiChat.verification.stat.earliest': 'Earliest',
  'epiChat.verification.stat.latest': 'Latest',
  'epiChat.verification.stat.medianDate': 'Median date',
  'epiChat.verification.stat.otherCategories': 'Other categories',
  'epiChat.verification.stat.otherCategoriesWithCount': 'Other categories ({count})',
  'epiChat.verification.stat.dataset': 'Dataset',
  'epiChat.verification.stat.generated': 'Generated',

  'epiChat.verification.value.patients': '{count} patients',
  'epiChat.verification.value.patientsWithPercent': '{count} patients ({percent})',
  'epiChat.verification.chip.study': 'Study: {period}',
  'epiChat.verification.badge.cached': '⟲ cached',
  'epiChat.verification.failed.title': 'Verification failed',
  'epiChat.verification.failed.subtitle': 'An error prevented this variable from being verified.',
  'epiChat.verification.error.subtitle':
    'Verification could not complete — one of its checks did not run. Re-run verification; if it fails the same way again, the variable itself likely needs fixing.',
  'epiChat.verification.empty': 'No verification runs',
  'epiChat.verification.emptySubtitle':
    'The Research Assistant will surface distribution results once verification is complete.',
  'epiChat.verification.historyToggle': 'History ({count})',
  'epiChat.verification.isolationDisclaimer':
    'Results show a summary of patient-level values for this variable using the parameters below and may differ when applied to a cohort or analytical dataset.',

  // DescriptionTab — description and output sections
  'epiChat.descriptionTab.empty':
    'No description yet. The agent will fill this in once it has a working draft.',
  'epiChat.descriptionTab.section.description': 'Description',
  'epiChat.descriptionTab.section.alias': 'Alias',
  'epiChat.descriptionTab.section.output': 'Output',
  'epiChat.descriptionTab.label.format': 'Format',
  'epiChat.descriptionTab.label.values': 'Values',
  'epiChat.descriptionTab.outputType.boolean': 'Boolean',
  'epiChat.descriptionTab.outputType.numeric': 'Numeric',
  'epiChat.descriptionTab.outputType.string': 'String',
  'epiChat.descriptionTab.outputType.date': 'Date',
  'epiChat.descriptionTab.values.boolean': 'True; False',
  'epiChat.descriptionTab.values.date': 'YYYY-MM-DD',
  'epiChat.descriptionTab.outputValueType.boolean': 'True or False',
  'epiChat.descriptionTab.outputValueType.signed_integer': 'Integer, positive or negative',
  'epiChat.descriptionTab.outputValueType.unsigned_integer': 'Integer, 0 or greater',
  'epiChat.descriptionTab.outputValueType.unsigned_decimal': 'Decimal, 0 or greater',
  'epiChat.descriptionTab.outputValueType.signed_decimal': 'Decimal, positive or negative',
  'epiChat.descriptionTab.outputValueType.string': 'Text',
  'epiChat.descriptionTab.outputValueType.date': 'Date',

  // DescriptionTab — "Used in" section
  'epiChat.descriptionTab.section.usedIn': 'Used in',
  'epiChat.descriptionTab.section.usedInWithCount': 'Used in ({count})',
  'epiChat.descriptionTab.usedIn.column.type': 'Type',
  'epiChat.descriptionTab.usedIn.column.name': 'Name',
  'epiChat.descriptionTab.usedIn.type.cohort': 'Cohort',
  'epiChat.descriptionTab.usedIn.type.analyticalDataset': 'Analytical dataset',
  'epiChat.descriptionTab.usedIn.type.analyticalVariable': 'Variable',
  'epiChat.descriptionTab.usedIn.empty.title': 'Not used anywhere',
  'epiChat.descriptionTab.usedIn.empty.description':
    'This variable has not been used in any cohort, analytical dataset, or other variable.',

  // ConceptMappingsTable — read-only term→concept-group / inline-concept
  // mappings on the Definition tab (OR-6214).
  'epiChat.conceptMappings.heading': 'Concept mappings ({count})',
  'epiChat.conceptMappings.column.term': 'Term',
  'epiChat.conceptMappings.column.mappedTo': 'Mapped to',
  'epiChat.conceptMappings.empty': 'Needs a concept group',
  // ConceptGroupIdFallback — bug-6 fallback shown when the structured concept
  // mappings are empty but the artifact still carries concept-group ids.
  'epiChat.conceptGroupFallback.heading': 'Concept groups ({count})',
  'epiChat.conceptGroupFallback.unavailable':
    'This concept group is not available — its binding may still be in progress.',
  // OmopConceptDetailsDialog — single OMOP concept details (inline chip).
  'epiChat.omopConcept.title': 'Concept details',
  'epiChat.omopConcept.label.name': 'Name',
  'epiChat.omopConcept.label.conceptId': 'Concept ID',
  'epiChat.omopConcept.label.code': 'Code',
  'epiChat.omopConcept.label.vocabulary': 'Vocabulary',
  'epiChat.omopConcept.label.domain': 'Domain',
  'epiChat.omopConcept.label.standard': 'Standard',
  'epiChat.omopConcept.standard.yes': 'Standard',
  'epiChat.omopConcept.standard.no': 'Non-standard',
  'epiChat.omopConcept.error': 'Could not load concept details.',
  'epiChat.omopConcept.close': 'Close',

  // SqlTab — SQL code section
  'epiChat.sqlTab.empty': 'No SQL',
  'epiChat.sqlTab.emptySubtitle':
    'The Research Assistant will surface the SQL once the variable has been drafted.',
  'epiChat.sqlTab.copySql': 'Copy SQL',
  'epiChat.sqlTab.copied': 'Copied',
  // OR-6126 ProjectConceptGroupPreviewPage — read-only review surface for a
  // proposed concept group (rules + concepts + create), resolving latest-effective.
  'epiChat.conceptGroupPreview.fallbackName': 'Proposed concept group',
  'epiChat.conceptGroupPreview.subtitle': 'Proposed concept group',
  'epiChat.conceptGroupPreview.conceptCount': '{count, plural, one {# concept} other {# concepts}}',
  // OR-6288: the rule-based review tab is labelled "Definition" in the design
  // (it shows the concept group's definition — its include/exclude rules).
  'epiChat.conceptGroupPreview.tab.rules': 'Definition',
  'epiChat.conceptGroupPreview.tab.concepts': 'Concepts',
  // OR-6125: source→mapped audit for a map-first upload (only shown when one exists).
  'epiChat.conceptGroupPreview.tab.mapping': 'Mapping results',
  'epiChat.conceptGroupPreview.mapping.loadError':
    'Couldn’t load the mapping results. Please try reopening the review.',
  'epiChat.conceptGroupPreview.mapping.empty': 'No mapping results to show for this upload.',
  // OR-6288: Mapping Results grid column headers (Figma order + labels).
  'epiChat.conceptGroupPreview.mapping.col.type': 'Type',
  'epiChat.conceptGroupPreview.mapping.col.status': 'Status',
  'epiChat.conceptGroupPreview.mapping.col.omopConceptId': 'OMOP concept ID',
  'epiChat.conceptGroupPreview.mapping.col.conceptName': 'Concept name',
  'epiChat.conceptGroupPreview.mapping.col.vocabulary': 'Vocabulary',
  'epiChat.conceptGroupPreview.mapping.col.code': 'Code',
  'epiChat.conceptGroupPreview.mapping.col.standard': 'Standard',
  'epiChat.conceptGroupPreview.mapping.col.domain': 'Domain',
  'epiChat.conceptGroupPreview.mapping.col.class': 'Class',
  // OR-6125: delineates an uploaded (literal) group from a hierarchy-based proposal.
  // OR-6125 review: skipped (invalid) entries from a direct concept-id upload, shown in red so
  // the considered-but-excluded rows are visible in the panel, not just in the chat summary.
  'epiChat.conceptGroupPreview.skipped.title':
    '{count, plural, one {# entry was skipped} other {# entries were skipped}}',
  'epiChat.conceptGroupPreview.skipped.description':
    'These weren’t valid concept IDs, so they were considered but excluded from this group:',
  'epiChat.conceptGroupPreview.concepts.downloadTooltip': 'Download all concepts as CSV',
  'epiChat.conceptGroupPreview.concepts.downloadAria': 'Download CSV',
  'epiChat.conceptGroupPreview.created.note':
    'Created in the organization’s concept group library.',
  'epiChat.conceptGroupPreview.created.openButton': 'Open concept group',
  'epiChat.conceptGroupPreview.create.nameLabel': 'Concept group name',
  'epiChat.conceptGroupPreview.create.button': 'Create concept group',
  'epiChat.conceptGroupPreview.create.creating': 'Creating…',
  // The draft review action is an approval (the draft is already a listed
  // asset; approving publishes it to the org library). Replaces the Save copy
  // below on the Draft header.
  // TODO: cleanup with concept_group_approve_action ff
  'epiChat.conceptGroupPreview.approve.button': 'Approve',
  'epiChat.conceptGroupPreview.approve.approving': 'Approving…',
  // OR-6288 design: the draft review is step 2 of a two-step flow.
  'epiChat.conceptGroupPreview.stepper.title': 'Create concept group',
  'epiChat.conceptGroupPreview.step.upload': 'Upload',
  'epiChat.conceptGroupPreview.step.draft': 'Draft',
  'epiChat.conceptGroupPreview.step.review': 'Review',
  'epiChat.conceptGroupPreview.back': 'Back',
  // OR-6288 C2a: in-view step 1 — the name/upload panel.
  'epiChat.conceptGroupPreview.step1.intro':
    'Create a concept group by uploading a list of OMOP standard concept IDs. A template is available for download to ensure proper formatting and structure. After uploading the file, a preview of the concept group will be available for review.',
  'epiChat.conceptGroupPreview.step1.nameLabel': 'Concept group name',
  'epiChat.conceptGroupPreview.step1.dropzoneTitle': 'Drag & drop your spreadsheet',
  'epiChat.conceptGroupPreview.step1.dropzoneHint':
    'or, click to browse — one file, 4 MB max, .csv, .xlsx, or .xls',
  'epiChat.conceptGroupPreview.step1.agentDraftNote':
    'This draft was built by the assistant. To edit the list by hand, download the current concepts, adjust the file, and upload it — the uploaded list is used exactly as-is.',
  'epiChat.conceptGroupPreview.step1.downloadCurrent': 'Download current concepts (CSV)',
  'epiChat.conceptGroupPreview.step1.needsChat':
    'Uploading needs an attached conversation — open this draft from its project chat to replace the list.',
  'epiChat.conceptGroupPreview.step1.uploadError': 'The upload failed — please try again.',
  'epiChat.conceptGroupPreview.step1.cancel': 'Cancel',
  'epiChat.conceptGroupPreview.step1.downloadTemplate': 'Download template',
  'epiChat.conceptGroupPreview.step1.upload': 'Upload',
  'epiChat.conceptGroupPreview.step1.uploading': 'Uploading…',
  'epiChat.conceptGroupPreview.step1.uploadReceived':
    'Upload received — the assistant is building the new draft. It will appear in the conversation and the project asset list; the previous draft stays until you discard it.',
  'epiChat.conceptGroupPreview.step1.backToReview': 'Back to review',
  'epiChat.conceptGroupPreview.step1.namePlaceholder': 'Enter concept group name',
  'epiChat.conceptGroupPreview.step1.revert': 'Revert',
  'epiChat.conceptGroupPreview.step1.removeFile': 'Remove',
  'epiChat.conceptGroupPreview.save.button': 'Save',
  'epiChat.conceptGroupPreview.sourceFile.label': 'Source file',
  'epiChat.conceptGroupPreview.sourceFile.change': 'Change file',
  // Condensed header meta row (Type · Domain(s) · Owner · Last modified) —
  // mirrors the cohort / analytical-dataset detail headers.
  'epiChat.conceptGroupPreview.meta.typeLabel': 'Type:',
  'epiChat.conceptGroupPreview.meta.typeValue': 'Concept group',
  'epiChat.conceptGroupPreview.meta.ownerLabel': 'Owner:',
  'epiChat.conceptGroupPreview.meta.lastModifiedLabel': 'Last modified:',
  'epiChat.conceptGroupPreview.step1.nameTooLong':
    '{count}/{max} characters — the name must be {max} characters or fewer.',
  'epiChat.conceptGroupPreview.step2Blocked':
    'Upload the new file to continue — or revert to the current list to return to the review.',
  'epiChat.conceptGroupPreview.step1.currentList':
    'Current uploaded list — {count} concepts. Choose a new file to replace it.',
  // UC-4.2 (OR-6288): confirm before a re-upload discards the current draft.
  'epiChat.conceptGroupPreview.step1.replaceConfirm.title': 'Replace the uploaded file?',
  'epiChat.conceptGroupPreview.step1.replaceConfirm.body':
    'Replacing this file discards your reviewed mappings — continue?',
  'epiChat.conceptGroupPreview.step1.replaceConfirm.confirm': 'Replace file',
  'epiChat.conceptGroupPreview.step1.replaceConfirm.cancel': 'Cancel',
  // OR-6288 finding: live name validation on the Step 1 field (parity with the
  // legacy create modal) — a duplicate is flagged as you type, before Review.
  'epiChat.conceptGroupPreview.step1.nameExists':
    'A concept group with this name already exists. Choose a different name.',
  'epiChat.conceptGroupPreview.step1.charCount': '{count}/{max} characters',
  'epiChat.conceptGroupPreview.create.nameRequired': 'Enter a name for the concept group.',
  'epiChat.conceptGroupPreview.create.duplicateName':
    'A concept group with this name already exists. Choose a different name.',
  'epiChat.conceptGroupPreview.create.error':
    'Something went wrong creating the concept group. Please try again.',
  // OR-6288 Stage C CAS: the draft moved (edited in chat) after this review
  // surface loaded — publishing is refused; the page refetches so the researcher
  // re-reviews the current definition, then creates again.
  'epiChat.conceptGroupPreview.create.conflict':
    'This draft changed since you opened it — review the current definition, then create again.',
  'epiChat.conceptGroupPreview.createdToast': 'Concept group “{name}” created.',
  // Inline-editable title (shared by the draft + created concept-group headers), mirroring the
  // analytical-variable name edit: click the title to edit, Enter saves / Esc cancels.
  'epiChat.conceptGroupName.editAria': 'Edit concept group name',
  'epiChat.conceptGroupName.saveAria': 'Save name',
  'epiChat.conceptGroupName.cancelAria': 'Cancel editing name',
  'epiChat.conceptGroupName.required': 'Enter a name for the concept group.',
  'epiChat.conceptGroupName.renameError': 'Couldn’t rename the concept group. Please try again.',
  // OR-6657: uniqueness and length are only judged when the rename is committed.
  // TODO: cleanup with concept_group_rename ff
  'epiChat.conceptGroupName.duplicate':
    'A concept group with this name already exists. Choose a different name.',
  'epiChat.conceptGroupName.tooLong': 'Use 100 characters or fewer.',
  'epiChat.conceptGroupName.conflict':
    'This draft changed since you opened it. Refresh, then rename it again.',
  // Header (top-right action + status), redesigned to mirror the artifact detail
  // headers (cohort/AV) — primary action top-right, clean metadata row.
  'epiChat.conceptGroupPreview.status.draft': 'Draft',
  'epiChat.conceptGroupPreview.domainsLabel': 'Domains',
  // Summary + Rules are distinct sections on the Rules tab.
  'epiChat.conceptGroupPreview.summary.heading': 'Summary',
  'epiChat.conceptGroupPreview.rules.heading': 'Rules',
  // OR-6322: restored — dropped in OR-6288 while still referenced by the Definition tab.
  'epiChat.conceptGroupPreview.rules.loadError':
    'Couldn’t load the proposed rules. Please try reopening the review.',
  'epiChat.conceptGroupPreview.rules.empty': 'This proposal has no per-seed rules to show.',
  // Rules tab rendered as a grid: a row per seed with boolean check columns.
  'epiChat.conceptGroupPreview.rules.col.concept': 'Concept',
  'epiChat.conceptGroupPreview.rules.col.id': 'ID',
  'epiChat.conceptGroupPreview.rules.col.vocabulary': 'Vocabulary',
  'epiChat.conceptGroupPreview.rules.col.included': 'Included',
  'epiChat.conceptGroupPreview.rules.col.descendants': 'Descendants',
  'epiChat.conceptGroupPreview.rules.col.mapped': 'Mapped',
  // OR-6288 Figma alignment: Definition tab columns + Include/Exclude action pill.
  'epiChat.conceptGroupPreview.definition.col.omopId': 'OMOP concept ID',
  'epiChat.conceptGroupPreview.definition.col.conceptName': 'Concept name',
  'epiChat.conceptGroupPreview.definition.col.action': 'Action',
  'epiChat.conceptGroupPreview.definition.action.include': 'Include',
  'epiChat.conceptGroupPreview.definition.action.exclude': 'Exclude',
  // OR-6288: shared metadata strip shown above each review tab's table.
  'epiChat.conceptGroupPreview.meta.conceptGroupLabel': 'Concept group:',
  'epiChat.conceptGroupPreview.meta.domainsLabel': 'Domain(s):',
  'epiChat.conceptGroupPreview.meta.conceptsLabel': 'Concepts:',
  'epiChat.conceptGroupPreview.meta.conceptsFoundLabel': 'Concepts found:',
  'epiChat.conceptGroupPreview.meta.conceptsNotFoundLabel': 'Concepts not found:',
  'epiChat.conceptGroupPreview.meta.downloadAria': 'Download concept group as CSV',
  // Created concept-group detail view (right pane) — the preview resolves to
  // this in place once created, and the /concept-group/:id route renders it too.
  'epiChat.conceptGroup.detail.domains': 'Domains',
  'epiChat.conceptGroup.detail.owner': 'Owner',
  'epiChat.conceptGroup.detail.lastModified': 'Last modified',
  'epiChat.conceptGroup.detail.conceptCount': '{count, plural, one {# concept} other {# concepts}}',
  'epiChat.conceptGroup.detail.searchPlaceholder': 'Search name, code, or id',
  'epiChat.conceptGroup.detail.downloadTooltip': 'Download all concepts as CSV',
  'epiChat.conceptGroup.detail.downloadAria': 'Download CSV',
  'epiChat.conceptGroup.detail.loadError': 'Couldn’t load this concept group. Please try again.',
  // OR-6288 Stage C: the Draft asset's Approve action + status chip.
  'epiChat.conceptGroup.detail.approve': 'Approve',
  'epiChat.conceptGroup.detail.approveError':
    'Couldn’t approve this concept group. Please try again.',
  'epiChat.conceptGroup.detail.approveConflict':
    'This draft changed since you opened it — review the current definition, then approve again.',
  'epiChat.conceptGroup.detail.approveDuplicateName':
    'A concept group with this name already exists. Rename the draft, then approve.',
  'epiChat.conceptGroup.detail.empty': 'This concept group has no concepts.',
  // OR-6289: the Draft (not-yet-published) rule-definition section — seed concepts + rules.
  'epiChat.conceptGroup.draftDefinition.title': 'Definition',
  'epiChat.conceptGroup.draftDefinition.seedConcept': 'Seed concept',
  'epiChat.conceptGroup.draftDefinition.rule': 'Rule',
  'epiChat.conceptGroup.draftDefinition.descendants': 'Descendants',
  'epiChat.conceptGroup.draftDefinition.include': 'Include',
  'epiChat.conceptGroup.draftDefinition.exclude': 'Exclude',
  'epiChat.conceptGroup.draftDefinition.withDescendants': 'With descendants',
  'epiChat.conceptGroup.draftDefinition.selfOnly': 'This concept only',
  'epiChat.conceptGroup.detail.col.id': 'ID',
  'epiChat.conceptGroup.detail.col.name': 'Name',
  'epiChat.conceptGroup.detail.col.code': 'Code',
  'epiChat.conceptGroup.detail.col.vocabulary': 'Vocabulary',
  'epiChat.conceptGroup.detail.col.domain': 'Domain',
  // Shared concepts explorer (toolbar + grid) used by BOTH the preview Concepts
  // tab and the created concept-group detail, so the two look + operate alike.
  'epiChat.concepts.searchPlaceholder': 'Search name, code, or id',
  'epiChat.concepts.filter.all': 'All',
  'epiChat.concepts.filter.standard': 'Standard',
  'epiChat.concepts.filter.nonStandard': 'Non-standard',
  // OR-6288 Figma alignment: spell out the concept columns to match the design.
  'epiChat.concepts.col.id': 'OMOP concept ID',
  'epiChat.concepts.col.name': 'Concept name',
  'epiChat.concepts.col.code': 'Concept code',
  'epiChat.concepts.col.vocabulary': 'Vocabulary',
  // OR-6125 review: the concepts grid mirrors the mapping-results "Standard" column —
  // a Yes/No flag, not a "Standard"/"Non-standard" type label.
  'epiChat.concepts.col.standard': 'Standard',
  'epiChat.concepts.col.domain': 'Domain',
  'epiChat.concepts.standardValue.yes': 'Yes',
  'epiChat.concepts.standardValue.no': 'No',
  'epiChat.concepts.downloadTooltip': 'Download all concepts as CSV',
  'epiChat.concepts.downloadAria': 'Download CSV',
  'epiChat.concepts.empty': 'No concepts match this view.',
  'epiChat.concepts.loadError': 'Couldn’t load concepts. Please try again.',

  // OR-6123 (Batch A) — Research Assistant welcome greeting, the client-side
  // render of a chat's zero-message empty state (never a stored/streamed
  // message). The copy is QA-locked byte-for-byte (TC-01 / TC-02): each
  // paragraph and each example bullet is its own id so every string stays
  // verbatim and is asserted directly against this catalog.
  //
  // "first" variant (AC1) — the project's first-ever chat: lead paragraph,
  // an example-prompt lead-in, then three bulleted examples.
  'epiChat.welcome.first.intro':
    "Hi! I'm your Research Assistant and I'm here to help you answer your research questions. Tell me what you're working on and we can get started.",
  'epiChat.welcome.first.examplesLead': 'For example, you could describe:',
  'epiChat.welcome.first.example.population': 'A patient population or cohort you want to identify',
  'epiChat.welcome.first.example.measure': 'An outcome, exposure, or covariate you want to measure',
  'epiChat.welcome.first.example.question': 'A research question you want to explore',
  // "returning" variant (AC4) — every other empty chat: two paragraphs, no
  // bullets.
  'epiChat.welcome.returning.intro':
    "Hi again! I'm here to help you answer your research questions. I have access to all your project work and can pick up from any previous conversations.",
  'epiChat.welcome.returning.followup': "Tell me what you're working on and we can get started.",

  // UnifiedIntentReview (OR-6018) — tooltip on a bound concept-group chip whose
  // group is not in the project pool.
  'epiChat.intent.conceptGroupUnavailable': 'Concept group not available',
  // UnifiedIntentReview (OR-6018) — help affordance on the Concept mappings
  // section explaining the domain-scoped picker + how to get an unlisted group.
  'epiChat.intent.conceptGroupsScopedHelp':
    "Only concept groups matching this term's clinical domain are shown, so the full library isn't listed. Don't see the one you want? Either ask the assistant to change the variable — use “Edit before approving” or “Redirect” — so it re-derives the mapping, or make sure the concept group exists in this project (you can ask the assistant to create it for this term), then it will appear here.",
  // OR-6290 (AV-14) — intent-checkpoint Approve button under the asset-workflow
  // flow. The review lives on the AV asset page; approval is a chat message,
  // shown only while the checkpoint is the latest pending message. There is no
  // Edit button — to change the variable the researcher types into chat.
  'epiChat.intent.approveButton': 'Approve',
  // Deterministic review prompt rendered with the Approve button when the
  // intent-checkpoint message carries no prose of its own (the model ends its
  // turn straight after the checkpoint tool call). Named variant when the
  // sibling AV card is present; generic otherwise.
  'epiChat.intent.reviewPrompt':
    "I've created the variable {name}. Review the definition in the workspace, then let me know if you'd like to approve it or make changes.",
  'epiChat.intent.reviewPromptGeneric':
    "I've created the variable draft. Review the definition in the workspace, then let me know if you'd like to approve it or make changes.",
  // OR-6292: the cohort-plan variants of the same deterministic review prompt —
  // the cohort detail page is the review surface for the plan's criteria.
  'epiChat.cohortPlan.reviewPrompt':
    "I've drafted the cohort {name}. Review its criteria on the cohort page, then let me know if you'd like to approve the plan or make changes.",
  'epiChat.cohortPlan.reviewPromptGeneric':
    "I've drafted the cohort plan. Review its criteria on the cohort page, then let me know if you'd like to approve the plan or make changes.",
  // OR-6368: the edit-gate variants — a `request_approval` re-surface stamps
  // asset_operation="updated" on the envelope, and the review line stops
  // claiming "I've created …" for an update.
  'epiChat.intent.updateReviewPrompt':
    "I've updated the variable {name}. Review the changes in the workspace, then let me know if you'd like to approve them or make further changes.",
  'epiChat.intent.updateReviewPromptGeneric':
    "I've updated the variable draft. Review the changes in the workspace, then let me know if you'd like to approve them or make further changes.",
  'epiChat.cohortPlan.updateReviewPrompt':
    "I've updated the cohort {name}. Review its criteria on the cohort page, then let me know if you'd like to approve the plan or make further changes.",
  'epiChat.cohortPlan.updateReviewPromptGeneric':
    "I've updated the cohort plan. Review its criteria on the cohort page, then let me know if you'd like to approve the plan or make further changes.",
  // A multi-variable turn is coalesced by the backend into ONE combined
  // intent checkpoint (member_count > 1) rendered through the single
  // IntentApprovePrompt — this is its count-based review line.
  'epiChat.intent.approveAllReviewPrompt':
    "I've created {count} variables. Review them in the workspace, then let me know if you'd like to approve them or make changes.",
  // Combined-card variants for a turn that only edited variables, and for a
  // turn that both created and edited them (asset_operation "mixed").
  'epiChat.intent.approveAllUpdatedReviewPrompt':
    "I've updated {count} variables. Review them in the workspace, then let me know if you'd like to approve them or make changes.",
  'epiChat.intent.approveAllMixedReviewPrompt':
    "I've created or updated {count} variables. Review them in the workspace, then let me know if you'd like to approve them or make changes.",
  // The combined-gate Approve button label — one click approves every
  // coalesced analytical-variable draft.
  'epiChat.intent.approveAllButton': 'Approve all ({count})',
  // A multi-cohort turn is coalesced by the backend into ONE combined
  // cohort_plan checkpoint (member_count > 1) — this is its count-based
  // review line, mirroring epiChat.intent.approveAllReviewPrompt.
  'epiChat.cohortPlan.approveAllReviewPrompt':
    "I've drafted {count} cohorts. Review their criteria on the cohort pages, then let me know if you'd like to approve them or make changes.",

  // process_analysis checkpoint — review line and Process button.
  'epiChat.processAnalysis.reviewPrompt':
    'The analysis {name} is ready. Would you like to process it?',
  'epiChat.processAnalysis.reviewPromptGeneric':
    'The analysis is ready. Would you like to process it?',
  'epiChat.processAnalysis.processedMessage': 'Process this analysis.',
  'epiChat.processAnalysis.processButton': 'Process',
  'epiChat.processAnalysis.stagedChangesTooltip':
    'Save or revert your changes before processing — only the saved version is processed.',

  // OR-6504: a parameterized variable FAMILY — several variables sharing one
  // definition and differing in exactly one thing. These must NOT reuse the
  // approve-all strings above: NOTHING exists at this point — approval is what
  // creates the variables — so "I've created {count}" would be wrong in both
  // count and tense, and "Approve all (N)" would describe approving N reviewed
  // drafts rather than authorising N to be created. Both gates can appear in the
  // same product, so sharing the copy would make two different actions look
  // identical.
  'epiChat.variableFamily.reviewPrompt':
    "Rather than {count} separate drafts, I'll set them up as a single group — review the shared definition once, then I'll create all {count}:",
  // The group card's kind row, mirroring the per-member cards' "Variable".
  'epiChat.variableFamily.groupKindLabel': 'Variable group · {count} variables',
  'epiChat.variableFamily.groupCardAriaLabel': 'Open {name}, a group of {count} variables',
  'epiChat.variableFamily.reviewDirective':
    'Review the shared definition, then approve to create all {count} variables at once.',

  // OR-6504: the GROUP's details page. Mirrors a single variable's Definition
  // tab section-for-section — the group IS a variable definition, one of whose
  // fields is a parameter rather than a value.
  'epiChat.variableFamilyPage.aliasLabel': 'Alias',
  'epiChat.variableFamilyPage.descriptionLabel': 'Description',
  'epiChat.variableFamilyPage.valuesIntro':
    'Individual variables will be created where {token} is one of:',
  'epiChat.variableFamilyPage.outputLabel': 'Output',
  'epiChat.variableFamilyPage.outputFormat': 'Format',
  'epiChat.variableFamilyPage.outputValues': 'Values',
  // The heading, Term and Mapped-to columns come from the SHARED mappings table
  // (epiChat.conceptMappings.*), so the group page and the variable page cannot
  // drift. Only the group-specific additions live here.
  'epiChat.variableFamilyPage.conceptMappingsCaption':
    'Shared across the group — each term is mapped once. "Applied to" shows which of the numbered variables above reference it.',
  'epiChat.variableFamilyPage.mappingAppliedTo': 'Applied to',
  // Names the side of the index date, and stops there: the drafter's predicates
  // include the index day while the descriptions say "following", so spelling out
  // day boundaries would be precisely wrong one way or the other.
  'epiChat.variableFamilyPage.windowAfterIndex':
    '{value, plural, one {# {unit}} other {# {unit}s}} after the index date',
  'epiChat.variableFamilyPage.windowBeforeIndex':
    '{value, plural, one {# {unit}} other {# {unit}s}} before the index date',
  // The visible button label is the SHARED 'epiChat.intent.approveAllButton'.
  // Spelled out for the accessible name only — "build all 10" read on its own
  // leaves "10 what?" unanswered, while the visible label must stay short
  // enough to survive a narrowed chat panel.
  'epiChat.variableFamily.approveButtonAriaLabel': 'Approve and build all {count} variables',
  // Lands in the transcript as the researcher's own turn, so it must not claim
  // the variables already exist.
  'epiChat.variableFamily.approvedMessage':
    'Approved — build all {count} variables from this definition.',

  // Inline chat asset card (object-cards spec, Figma 1491-64018).
  'epiChat.assetCard.viewDetails': 'View details',

  // Condensed card for a run of concept-group drafts (OR-6486).
  'epiChat.conceptGroupBatch.kindLabel': 'Concept group',
  'epiChat.conceptGroupBatch.count': '{count, plural, one {# group} other {# groups}}',
  'epiChat.conceptGroupBatch.showMore': 'Show {count} more',
  'epiChat.conceptGroupBatch.showLess': 'Show less',

  // Pinned clarifying-question panel (research_assistant_pinned_clarify).
  // TODO: cleanup with research_assistant_pinned_clarify ff
  'epiChat.clarify.dismiss': 'Dismiss — reply in the box below',
  'epiChat.clarify.other': 'Something else…',

  // LibraryMatchCard — the "inline ranked list" library-match / reference-pick
  // checkpoint card (OR-6338).
  'epiChat.libraryMatch.kindLabel': 'Variable match',
  'epiChat.libraryMatch.viewDetails': 'View details',
  'epiChat.libraryMatch.noneFit': 'None fit?',
  'epiChat.libraryMatch.buildNew': 'Build new',
  'epiChat.libraryMatch.reusedFromLibrary': 'Reused from library',
  // Headline wording leads with whether a `primary` was surfaced, not a raw count.
  'epiChat.libraryMatch.headline.primaryOnly': 'Found a close match for <strong>{name}</strong>',
  'epiChat.libraryMatch.headline.primaryAndOne':
    'Found a close match for <strong>{name}</strong>, and 1 other similar variable',
  'epiChat.libraryMatch.headline.primaryAndMany':
    'Found a close match for <strong>{name}</strong>, and {otherCount} other similar variables',
  'epiChat.libraryMatch.headline.similarOne': 'Found a variable similar to <strong>{name}</strong>',
  'epiChat.libraryMatch.headline.similarMany':
    'Found {otherCount} variables similar to <strong>{name}</strong>',

  // Reference mode (purpose=search_reference_variable) — the researcher is
  // choosing which variable to follow as a pattern, not which one to adopt.
  'epiChat.libraryMatch.referenceKindLabel': 'Pattern to follow',
  'epiChat.libraryMatch.followThis': 'Follow this',
  'epiChat.libraryMatch.follow': 'Follow',
  'epiChat.libraryMatch.followedAsPattern': 'Followed as pattern',
  // The reference question doesn't need the drafted variable's name repeated
  // back; it's already shown as the requested variable.
  'epiChat.libraryMatch.referenceHeadlineSimple': 'Which variable to follow?',

  // Non-reference "Use" actions — the reuse counterpart to Follow/Follow this.
  'epiChat.libraryMatch.useThis': 'Use this',
  'epiChat.libraryMatch.use': 'Use',

  // Variable-match step and rows inside the Review card.
  'epiChat.variableMatch.matchFor': 'Match for <strong>{name}</strong>',
  'epiChat.variableMatch.viewDetails': 'View details',
  'epiChat.variableMatch.buildNew': 'Build a new variable',

  // ReviewCard — pinned card for a turn's questions and library matches
  // (flag research_assistant_review_card).
  'epiChat.review.title': 'Review',
  'epiChat.review.position': '{current} of {total}',
  'epiChat.review.previous': 'Previous item',
  'epiChat.review.next': 'Next item',
  'epiChat.review.close': 'Close — reply in the box below',
  'epiChat.review.intro':
    '{kinds, select, both {Before I continue, I have a couple of questions and some variable matches for you to review.} questions {Before I continue, I have {count, plural, one {a question} other {a few questions}} for you.} other {Here’s what I found in your library for the {count, plural, one {variable} other {# variables}} you asked for. Pick one for each — nothing is saved until you confirm.}}',
  'epiChat.review.reviewIntro':
    'Here’s everything you picked. Confirm to continue, or change anything first.',
  'epiChat.review.questionPosition': 'Question {current} of {total}',
  'epiChat.review.customPlaceholder': 'Type your answer',
  'epiChat.review.send': 'Send',
  'epiChat.review.confirm': 'Confirm',
  'epiChat.review.skipped': 'Skipped',
  'epiChat.review.closedBody':
    'Dismissed without answering, so nothing here was applied. {open} still open.',
  'epiChat.review.openQuestions': '{count, plural, one {# question} other {# questions}}',
  'epiChat.review.openMatches':
    '{count, plural, one {# variable match} other {# variable matches}}',
  'epiChat.review.reopen': 'Reopen',
};
